import { SearchBoxComponentService } from '@spartacus/storefront';
import { Injectable } from '@angular/core';
import { Ga4GgSearchViewAutoCompleteResultsEvent } from '../../events/analytics/ga4/search/ga4-gg-search-view-auto-complete-results.event';
@Injectable({
  providedIn: 'root',
})
export class GgSearchBoxComponentService extends SearchBoxComponentService {
  dispatchGa4GgSearchViewAutoCompleteResultsEvent(): void {
    this.eventService.dispatch<Ga4GgSearchViewAutoCompleteResultsEvent>(
      {
        event: 'view_automcomplete_results',
      },
      Ga4GgSearchViewAutoCompleteResultsEvent
    );
  }
}
